import Styles from 'src/components/Styles';
import Localized from 'src/constants/AppStrings';
import {
  RenderItemProps,
  RenderMenuItemProps,
} from 'src/components/elements/cart/descriptor/DescriptorType';
import {
  Image,
  Platform,
  StyleProp,
  StyleSheet,
  Text,
  Pressable,
  View,
  ViewStyle,
} from 'react-native';
import AVText from 'src/components/elements/AVText';
import {
  DietaryHealthAlert,
  DietaryHealthGood,
  DietaryHealthWarning,
} from 'src/components/img/svg/DietaryHealthGrades';
import AVFormattedCurrency from 'src/components/elements/AVFormattedCurrency';
import AccountStore from 'src/stores/AccountStore';
import PlusSignIcon from '../../../img/svg/PlusSignIcon';
import Pay365MenuItemBoilerPlate from '../../../img/svg/menuItemsBoilerplateIcons/365PayMenuItemBoilerPlate';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import {scanAndPayTemplate} from 'src/components/screens/scanAndPay/templates/scanandPayThemeHelper';

type ProductCatButtonStyle = StyleProp<ViewStyle>;

const {mainFontFamily, bodyLargeFontSize, bodyFontSize} = getLayoutDescriber();

function cartProductStyleDescriptor() {
  return StyleSheet.create({
    description: {
      marginHorizontal: Styles.Spacing.m2,
      justifyContent: 'center',
      fontFamily: mainFontFamily(),
      fontSize: scanAndPayTemplate.selectedProductsFont,
      lineHeight: 18,
      color: Styles.Colors.PayNew.black01,
    },
    cartProductDescription: {
      flex: 0.7,
      marginHorizontal: Styles.Spacing.m2,
      justifyContent: 'center',
      fontFamily: mainFontFamily(),
      fontSize: scanAndPayTemplate.selectedProductsFont,
      lineHeight: 18,
      color: Styles.Colors.PayNew.black01,
    },
    status: {
      marginHorizontal: Styles.Spacing.m2,
      color: Styles.dangerColor,
      textTransform: 'uppercase',
    },
    container: {
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: Styles.Spacing.m3,
    },
    mainSection: {flex: 1, flexDirection: 'row'},
    alignStart: {alignItems: 'flex-start'},
    alignCenter: {alignItems: 'center'},
    deleteButton: {justifyContent: 'center'},
    cartItemMainKey: {
      flexDirection: 'row',
      flex: 1,
      justifyContent: 'space-between',
    },
    productCartItem: {
      flexDirection: 'row',
      flex: 1,
      justifyContent: 'space-between',
    },
    cartDescriptionView: {flex: 1, rowGap: 4},
    column: {flexDirection: 'column'},
    cartTagIcon: {justifyContent: 'center', alignSelf: 'flex-start'},
    supIconMargin: {marginTop: 4},
    cartPromoTextView: {flex: 0.7, flexDirection: 'row', left: 5},
    cartPrice: {
      fontWeight: '400',
      fontSize: scanAndPayTemplate.cartItemPrice,
      fontFamily: mainFontFamily(),
      color: Styles.Colors.PayNew.black01,
      flex: 0.3,
      textAlign: 'right',
    },
    cartRewardPoints: {
      fontSize: bodyLargeFontSize(),
      fontWeight: '400',
      fontFamily: mainFontFamily(),
      color: scanAndPayTemplate.rewardsPayColor,
      paddingLeft: Styles.Spacing.m2,
    },
    cartPricePromo: {
      color: Styles.Colors.PayNew.black01,
      fontWeight: '400',
      fontSize: scanAndPayTemplate.cartItemPrice,
      fontFamily: mainFontFamily(),
    },
    strikeThrough: {textDecorationLine: scanAndPayTemplate.priceDecoration},
    supDescription: {flex: 0.8, marginHorizontal: 2},
    titleMargin: scanAndPayTemplate.checkoutStyles.itemLabelMargin,
    rewardPrice: {
      textDecorationLine: 'line-through',
    },
  });
}

export function searchFieldLabelDescriptor(data: typeof Localized): string {
  return `${data.Labels.searchproducts}...`;
}

export function productCatSelectedStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    backgroundColor: Styles.Colors.PayNew.primary01,
    borderColor: Styles.Colors.PayNew.primary01,
    overflow: 'hidden',
  };
}

export function productCatButtonStyleDescriptor(): ProductCatButtonStyle {
  return {
    backgroundColor: Styles.Colors.PayNew.white01,
    borderRadius: Styles.Spacing.m4,
    minHeight: 38,
    marginRight: Styles.Spacing.m2,
    paddingHorizontal: Styles.Spacing.m3,
    paddingVertical: Styles.Spacing.m2,
    borderWidth: 1,
    overflow: 'hidden',
    borderColor: Styles.Colors.PayNew.neutralHuesBase09,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    elevation: 3,
  };
}

export function productCatTextStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    fontSize: bodyFontSize(),
    fontWeight: '400',
    color: Styles.Colors.PayNew.black01,
    fontFamily: Styles.FontFamily.aeonikRegular,
    lineHeight: 20,
  };
}
export function productCatSelectedTextStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    color: Styles.Colors.PayNew.white01,
    fontWeight: '700',
  };
}

export function quickAddOnsTextStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    color: Styles.Colors.PayNew.black01,
    fontWeight: '700',
    fontSize: Styles.Fonts.f0,
    marginTop: Styles.Spacing.m1,
    width: 110,
  };
}
export function quickAddOnsPointsTextStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    color: Styles.Colors.PayNew.darkHuesBase04,
    fontWeight: '300',
    fontSize: Styles.Fonts.f0,
    marginTop: Styles.Spacing.m1,
  };
}

export function quickAddOnsViewContainerStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    alignItems: 'start',
    justifyContent: 'center',
    marginLeft: Styles.Spacing.m2,
    marginRight: Styles.Spacing.m2,
    marginBottom: Styles.Spacing.m2,
    borderRadius: Styles.Spacing.m1,
  };
}
export function quickAddOnsProductImageContainerStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {width: 110, height: 110, borderRadius: 8};
}
export function quickAddOnsProductPlusIconStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {position: 'absolute', zIndex: 1, bottom: 0, right: 0};
}

export function productCatrenderItem({
  item,
  index,
  selectedCategory,
  categoriesLength,
  onCategoryPress,
}: RenderItemProps): JSX.Element {
  return (
    <Pressable
      role="button"
      onPress={() => onCategoryPress(item)}
      key={index}
      nativeID={`Btn ${item.name} ${Localized.Buttons.category}`}
      accessibilityRole="button"
      style={{
        ...(Platform.OS === 'web' ? {} : styles.shadow),
      }}
      accessible
      testID="qa_category_btn"
      nativeID="qa_category_btn"
    >
      <View
        accessible
        style={[
          productCatButtonStyleDescriptor(),
          selectedCategory === item.key && productCatSelectedStyleDescriptor(),
          index === 0 && styles.firstItem,
          index === categoriesLength - 1 && styles.lastItem,
        ]}
      >
        <Text
          style={[
            productCatTextStyleDescriptor(),
            selectedCategory === item.key &&
              productCatSelectedTextStyleDescriptor(),
          ]}
          accessibilityHint="Tap to filter products by selected category"
          accessibilityLabel={`${item.name} ${Localized.Buttons.category}`}
          aria-label={`${item.name} ${Localized.Buttons.category}`}
        >
          {item?.name}
        </Text>
      </View>
    </Pressable>
  );
}

export function menuItemCategoryRenderItem({
  item,
  index,
  categoriesLength,
  onMenuItemPress,
}: RenderMenuItemProps): JSX.Element {
  return (
    <Pressable
      role="button"
      onPress={() => onMenuItemPress(item)}
      key={index}
      accessibilityRole="button"
      style={{
        ...(Platform.OS === 'web' ? {} : styles.shadow),
      }}
    >
      <View
        accessible
        style={[
          quickAddOnsViewContainerStyleDescriptor(),
          index === 0 && styles.firstItem,
          index === categoriesLength - 1 && styles.lastItem,
        ]}
      >
        <View>
          <Pressable
            style={quickAddOnsProductPlusIconStyleDescriptor()}
            onPress={() => onMenuItemPress(item, true)}
            hitSlop={Styles.HitSlop_4}
          >
            <PlusSignIcon />
          </Pressable>
          {item.imageUrl ? (
            <Image
              accessible={true}
              accessibilityLabel="Product image"
              accessibilityRole="image"
              aria-label="Product image"
              role="img"
              style={quickAddOnsProductImageContainerStyleDescriptor()}
              source={{uri: item.imageUrl}}
              resizeMode={'cover'}
            />
          ) : (
            <Pay365MenuItemBoilerPlate />
          )}
        </View>
        <Text
          style={[quickAddOnsTextStyleDescriptor(), styles.font]}
          accessibilityHint="Tap to filter products by selected category"
          accessibilityLabel={`${item.name} ${Localized.Buttons.category}`}
          aria-label={`${item.name} ${Localized.Buttons.category}`}
        >
          {item?.name}
        </Text>
        {item?.rewardPoints > 0 && (
          <Text
            style={[quickAddOnsPointsTextStyleDescriptor(), styles.font]}
            accessibilityHint="Tap to filter products by selected category"
            accessibilityLabel={`${item.name} ${Localized.Buttons.category}`}
            aria-label={`${item.name} ${Localized.Buttons.category}`}
          >
            {item?.rewardPoints} points
          </Text>
        )}
      </View>
    </Pressable>
  );
}

export function caloriePromotionItem(
  nutritionColorDiscount: number,
  nutritionColorDisplayName: string,
  nutritionDisplayColor: string,
): JSX.Element {
  let healthGradeIcon: JSX.Element | false;
  if (nutritionDisplayColor?.toUpperCase() === 'GREEN') {
    healthGradeIcon = (
      <View
        accessible={true}
        accessibilityLabel="Health grade: good, "
        accessibilityRole="image"
        role="img"
        aria-label="Health grade: good, "
      >
        <DietaryHealthGood />
      </View>
    );
  } else if (nutritionDisplayColor?.toUpperCase() === 'YELLOW') {
    healthGradeIcon = (
      <View
        accessible={true}
        accessibilityLabel="Health grade: warning, "
        accessibilityRole="image"
        role="img"
        aria-label="Health grade: warning, "
      >
        <DietaryHealthWarning />
      </View>
    );
  } else if (nutritionDisplayColor?.toUpperCase() === 'RED') {
    healthGradeIcon = (
      <View
        accessible={true}
        accessibilityLabel="Health grade: alert, "
        accessibilityRole="image"
        role="img"
        aria-label="Health grade: alert, "
      >
        <DietaryHealthAlert />
      </View>
    );
  }

  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: Styles.Spacing.m2,
      }}
    >
      {healthGradeIcon}
      <AVText style={{marginLeft: Styles.Spacing.m2}}>
        {nutritionColorDisplayName}
      </AVText>
      <AVText style={{fontWeight: 'bold'}}>{' ('}</AVText>
      <AVFormattedCurrency
        style={{fontWeight: 'bold'}}
        value={nutritionColorDiscount}
        currency={AccountStore.getCurrency()}
        accessibilityLabel={`Discount: ${nutritionColorDiscount} dollars`}
        accessibilityRole="text"
        aria-label={`Discount: ${nutritionColorDiscount} dollars`}
      />
      <AVText style={{fontWeight: 'bold'}}>{')'}</AVText>
    </View>
  );
}

const styles = StyleSheet.create({
  firstItem: {
    marginLeft: Styles.Spacing.m3,
  },
  shadow: {
    marginBottom: Styles.Spacing.m1,
    minHeight: Styles.MinTouchableArea,
  },
  lastItem: {
    marginRight: Styles.Spacing.m3,
  },
  font: {
    fontFamily: Styles.FontFamily.aeonikRegular,
  },
});

export default {
  searchFieldLabelDescriptor,
  productCatSelectedStyleDescriptor,
  productCatButtonStyleDescriptor,
  productCatTextStyleDescriptor,
  productCatSelectedTextStyleDescriptor,
  productCatrenderItem,
  menuItemCategoryRenderItem,
  caloriePromotionItem,
  cartProductStyleDescriptor,
};
